import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { ReajustePacasForm } from "./components/ReajustePacasForm";
import "./styles/ReajustePacas.css";

class ReajustePacas extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        const { tipo, producto_id, es_conforme_bodega } =
            this.props.match.params;

        // la fila se identifica por lo que es, no por el id de su registro
        const fila = {
            tipo,
            producto_id,
            es_conforme_bodega: es_conforme_bodega === "true",
        };

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "92vw", margin: "auto" }}
            >
                <CardForm
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Reajuste de pacas por pallet"
                    col="12"
                >
                    <ReajustePacasForm
                        fila={fila}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(ReajustePacas);
